<template>
  <label class="app-input"
         :class="{'app-input--has-icon': hasIcon}"
  >
    <input v-model="inputValue"
           type="text"
           class="app-input__input"
           :placeholder="placeholder"
           @focus="$emit('focus', $event)"
    >

    <span class="app-input__icon"
          v-if="hasIcon"
    >
      <slot name="icon"></slot>
    </span>
  </label>
</template>

<script>
export default {
  name: "AppInput",
  props: {
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    hasIcon() {
      return !!this.$slots.icon
    }
  }
}
</script>

<style lang="scss">
$icon-width: 17px;
$padding: 10px;

.app-input {
  position: relative;
  width: 200px;
  height: 58px;
  background-color: $input-background-color;
  padding: $padding;
  color: $app-primary-color;

  &:after {
    content: "";
    position: absolute;
    right: $padding;
    top: 0;
    width: 20px;
    height: 100%;
    background: linear-gradient(90deg, rgba($input-background-color, 0), $input-background-color 90%);
    transition: width .2s;
  }

  &:focus-within:after {
    width: 0;
  }

  &__input {
    font-family: "DINCondensed", sans-serif;
    font-size: 2.5em;
    font-weight: 700;
    color: inherit;
    width: 100%;
    height: 100%;
    border: none;
    background-color: transparent;
    vertical-align: center;
    padding-top: 0;

    &::placeholder {
      color: $input-placeholder-color;
    }

  }

  &--has-icon:after {
    right: calc($icon-width + $padding);
  }

  &--has-icon &__input {
      width: calc(100% - $icon-width);
  }

  &__icon {
    position: absolute;
    right: $padding;
    top: 0;
    width: $icon-width;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    background-color: $input-background-color;
  }

}

@include smallerThan("xxl") {
  .app-input {
    width: 150px;

    &__input {
      font-size: 2em;
    }
  }
}

@include smallerThan("lg") {
  .app-input {
    width: 100%;
  }
}
</style>
